module.exports = __webpack_public_path__ + "img/form-sent.5979e6df.svg";